import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'

import VTLogoWhite from '../../assets/images/VT-Logo-White.svg'
import VTLogoPurple from '../../assets/images/VT-Logo-Purple.svg'
import { ThemeContext } from '../../context/themeContext'
import { MenuContext } from '../../context/menuContext'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { FrontendUrls } from '../../types/urls'

const SidebarLogo = () => {
  const { theme } = useContext(ThemeContext)
  const { miniMenu, setMiniMenu, collapseNavbar, navCollapsed, setNavCollapsed } = useContext(MenuContext)

  const onToggleMenu = () => {
    if (collapseNavbar) {
      // On mobile/tablet: close the drawer
      setNavCollapsed(!navCollapsed)
    } else {
      // On desktop: toggle mini menu
      setMiniMenu(!miniMenu)
    }
  }

  return (
    <div className="layout-sider-header">
      <Button className="btn-linebar-menu" type="link" onClick={onToggleMenu}>
        {collapseNavbar ? (
          // Mobile/tablet: show close icon
          <MenuFoldOutlined />
        ) : // Desktop: show expand/collapse based on mini menu state
        miniMenu ? (
          <MenuUnfoldOutlined />
        ) : (
          <MenuFoldOutlined />
        )}
      </Button>

      <Link to={FrontendUrls.home} className="site-logo">
        {theme === DARK_THEME ? <VTLogoWhite /> : <VTLogoPurple />}
      </Link>
    </div>
  )
}

// Memoize to prevent unnecessary re-renders
// Since this component uses context, it will still re-render when context values change
// But it won't re-render when parent components re-render for other reasons
export default React.memo(SidebarLogo)
